// Sale Policy advisor toggle inside the cart drawer.
// Delegated on document so it keeps working after the drawer re-renders via AJAX.
(function () {
  if (window.__salePolicyAdvisorBound) return;
  window.__salePolicyAdvisorBound = true;

  function closeAll(except) {
    document
      .querySelectorAll('.cart-item__sale-policy .advisor-text.show')
      .forEach(function (panel) {
        if (panel === except) return;
        panel.classList.remove('show');
        var wrapper = panel.closest('.advisor-wrapper');
        if (wrapper) wrapper.classList.remove('is-open');
        var trigger = wrapper && wrapper.querySelector('.advisor-title');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
  }

  function toggleFrom(contentAdvisor) {
    var wrapper = contentAdvisor.closest('.advisor-wrapper');
    if (!wrapper) return;
    var panel = wrapper.querySelector('.advisor-text');
    var title = wrapper.querySelector('.advisor-title');
    if (!panel || !title) return;
    var willOpen = !panel.classList.contains('show');
    closeAll(willOpen ? panel : null);
    panel.classList.toggle('show', willOpen);
    wrapper.classList.toggle('is-open', willOpen);
    title.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }

  document.addEventListener('click', function (event) {
    var closeBtn = event.target.closest('.cart-item__sale-policy .close-btn');
    if (closeBtn) {
      event.preventDefault();
      event.stopPropagation();
      var wrapper = closeBtn.closest('.advisor-wrapper');
      var trigger = wrapper && wrapper.querySelector('.advisor-title');
      closeAll(null);
      if (trigger) trigger.focus();
      return;
    }
    // The PDP advisor binds to .content-advisor, not the title/SVG itself.
    // Keep the panel passive so its contents do not toggle the advisor.
    if (event.target.closest('.cart-item__sale-policy .advisor-text')) return;
    var contentAdvisor = event.target.closest('.cart-item__sale-policy .content-advisor');
    if (contentAdvisor) {
      event.preventDefault();
      toggleFrom(contentAdvisor);
      return;
    }
    // Click outside any sale-policy advisor closes open panels.
    if (!event.target.closest('.cart-item__sale-policy')) closeAll(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var title = event.target.closest('.cart-item__sale-policy .advisor-title');
    if (!title) return;
    var contentAdvisor = title.closest('.content-advisor');
    if (!contentAdvisor) return;
    event.preventDefault();
    toggleFrom(contentAdvisor);
  });
})();
